"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../../../core/collapse"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h4", null, "Start List Notes");
var _ref2 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "These notes will be displayed to paddlers at the top of the start list.");
class StartListNotes extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isOpened: false
    });
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_onUpdateCompetitionNotes", value => {
      this.props.onUpdateCompetition(this.props.competitionID, 'startListNotes', value);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened,
      style: {
        marginBottom: 8
      }
    }, this.state.isOpened ? 'Hide Notes' : 'Add Start List Notes'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingBottom: 8
      }
    }, _ref, _ref2, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "RichText",
      name: "startListNotes",
      maxLength: 5000,
      value: this.props.startListNotes || {
        __html: ''
      },
      onChange: this._onUpdateCompetitionNotes
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(StartListNotes, undefined, (client, props) => ({
  onUpdateCompetition(id, field, value) {
    return client.update('Competition.set', {
      id,
      field,
      value
    });
  }
}));